
$(document).ready(function(){
  promoPopCookie();
  newsletterPopupA11y(); // WCAG 1.3.1, 2.4.3, 4.1.2 — dialog focus trap & restore
});

// WCAG 1.3.1, 2.4.3, 4.1.2 — Newsletter popup dialog accessibility.
// Installs a focus trap + Escape-to-close + focus restoration around
// #newsletter_popup WITHOUT modifying the existing open/close code paths
// (setTimeout-based open, two independent close click handlers).
// Visibility is observed via MutationObserver on the popup's style attr,
// which jQuery .fadeIn / .fadeOut mutate.
function newsletterPopupA11y() {
  var $popup = $('#newsletter_popup');
  if (!$popup.length) { return; }
  var popupEl = $popup[0];
  var $modal = $popup.find('.popup_modal');
  if (!$modal.length) { return; }
  var FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var previousFocus = null;
  var trapKeydown = null;

  function visibleFocusables() {
    return $modal.find(FOCUSABLE).filter(':visible');
  }

  function activateTrap() {
    if (trapKeydown) { return; } // idempotent
    previousFocus = document.activeElement;
    // Move focus into the dialog. Prefer first focusable; fall back to modal itself.
    var $focusables = visibleFocusables();
    var $target = $focusables.length ? $focusables.first() : $modal;
    setTimeout(function() { try { $target.trigger('focus'); } catch (_) {} }, 0);

    trapKeydown = function(e) {
      // Only act while popup is actually visible
      if (!$popup.is(':visible')) { return; }
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        // Delegate to the existing close path so cookie logic runs unchanged
        $popup.find('.close_popup').trigger('click');
        return;
      }
      if (e.key !== 'Tab' && e.keyCode !== 9) { return; }
      var focusables = visibleFocusables();
      if (!focusables.length) { e.preventDefault(); return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trapKeydown, true);
  }

  function deactivateTrap() {
    if (trapKeydown) {
      document.removeEventListener('keydown', trapKeydown, true);
      trapKeydown = null;
    }
    // Restore focus to whatever had it before the popup opened
    if (previousFocus && typeof previousFocus.focus === 'function') {
      try { previousFocus.focus(); } catch (_) {}
    }
    previousFocus = null;
  }

  // Watch for fadeIn / fadeOut driven style changes
  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function() {
      if ($popup.is(':visible')) { activateTrap(); }
      else if (trapKeydown) { deactivateTrap(); }
    });
    mo.observe(popupEl, { attributes: true, attributeFilter: ['style'] });
  }
}


// Popup Js
  
  function promoPopCookie() {
  var promoCookie = "promo-showed";
  var promoDelay = $("#newsletter_popup").data("promo-delay");
  var promoExpiry = $("#newsletter_popup").data("promo-expiry");
  var my_setcookie = $.cookie('promo-showed');
    
  if ($("#newsletter_popup").data("promo-enabled")) {
    if (typeof my_setcookie != "undefined") {
      if (Cookies.get(promoCookie) !== "1") {
        setTimeout(function() {
          $('.popup_overlay').fadeIn();
          $('#newsletter_popup').fadeIn();  
        }, promoDelay);
      }
    }
  }

  $("#newsletter_popup .close_popup").click(function(e) {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });	
    $('.popup_overlay').fadeOut();
    $('#newsletter_popup').fadeOut();
    e.preventDefault();
  });
    
    
  $('.popup_overlay').click(function () {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });
	$(this).hide();
	$('#newsletter_popup').fadeOut();
	e.preventDefault();
  });
};

$(document).ready( function () {
    var $form = $('#mc-embedded-subscribe-form');
    if ( $form.length > 0 ) {
      $('form input[type="submit"]').bind('click', function ( event ) {
        
          if($('#mce-EMAIL').val()!=""){
            
            window.mc.ajaxOptions.success = function(response) {
              if(response.result == "error" ){
				var err_msg = response.msg;
				$('#mce-error-response').text(err_msg);
				$('#mce-error-response').show();
                $('#mc-embedded-subscribe-form').hide();
              }else{
        		$('#mc-embedded-subscribe-form').hide();
                $('.newsletter_text').hide();              
                $('.newsletter_success_text').fadeIn();
                $('.popup_wrapper .popup_modal .popup-body').css({"justify-content":"inherit"});
              }
			};      
          }
      });
    }  
    window.setInterval(function(){
      if($("#mce-error-response").text().indexOf("<a href") > 0) {
        var textToUpdate = $("#mce-error-response").text().slice(0,$("#mce-error-response").text().indexOf("<a href"));
        $("#mce-error-response").text(textToUpdate);
      }
    },500);
});